import LocationsAutocomplete from './LocationsAutocomplete'

export default LocationsAutocomplete
